import {store} from 'macarons'
import Widget from './Widget.vue'
import GlobalFiltersWidget from './GlobalFiltersWidget'
import ViewsWidget from './ViewsWidget'
import CustomGraphStore from './store.js'
import config from './config'
import {Registry} from './graph'

export default {
  install (Vue, options) {    
    config.updateConfig(options)

    if (options.graphs) {
      Object.keys(options.graphs).forEach(k => {
        if (options.graphs[k]) {
          Registry.register(options.graphs[k])
        } else {
          Registry.unregister(k)
        }
      })
    }
    
    store.commit('registerWidget', {
      label: 'Graphique personnalisé',
      id: 'custom_graph',
      component: Widget,
      w: 12,
      h: 70
    })
    store.registerModule('customGraph', CustomGraphStore)

    if (options.globalFiltersWidget) {
      store.commit('registerWidget', {
        label: 'Filtres Globaux',
        id: 'custom_graph_global_filters',
        component: GlobalFiltersWidget,
        w: 12,
        h: 70
      })
    }

    if (options.viewsWidget) {
      store.commit('registerWidget', {
        label: 'Vue',
        id: 'custom_view',
        component: ViewsWidget,
        w: 12,
        h: 70
      })
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/index.js